import { render, staticRenderFns } from "./sitebod-card.vue?vue&type=template&id=21fb833d&scoped=true&"
import script from "./sitebod-card.vue?vue&type=script&lang=js&"
export * from "./sitebod-card.vue?vue&type=script&lang=js&"
import style0 from "./sitebod-card.vue?vue&type=style&index=0&id=21fb833d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb833d",
  null
  
)

export default component.exports